var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      [
        _c(
          "ul",
          { staticClass: "rating-box" },
          _vm._l(_vm.rate, function(index) {
            return _c("li", { key: index, staticClass: "rate" }, [
              index > _vm.level
                ? _c("img", { attrs: { src: "img/icons/empty-gem.png" } })
                : _vm._e(),
              index <= _vm.level
                ? _c("img", { attrs: { src: "img/icons/gem.png" } })
                : _vm._e()
            ])
          }),
          0
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }